import { PEER_COMPARISON_TITLE } from './constants';

const convertTooltipObject = (name, data) => {
    if (name === 'Scenario 1') {
        return {
            scenario: 1,
            rank: data.s1Rank,
            score: data.s1Score,
            peerScore: data.s1PeerScore,
            outlier: data.s1Outlier
        };
    }
    if (name === 'Scenario 2') {
        return {
            scenario: 2,
            rank: data.s2Rank,
            score: data.s2Score,
            peerScore: data.s2PeerScore,
            outlier: data.s2Outlier
        };
    }
    if (name === 'Scenario 3') {
        return {
            scenario: 3,
            rank: data.s3Rank,
            score: data.s3Score,
            peerScore: data.s3PeerScore,
            outlier: data.s3Outlier
        };
    }
    if (name === 'Scenario 4') {
        return {
            scenario: 4,
            rank: data.s4Rank,
            score: data.s4Score,
            peerScore: data.s4PeerScore,
            outlier: data.s4Outlier
        };
    }
};

export const getTitleOptionsForPeerComparison = () => ({
    left: 'left',
    text: PEER_COMPARISON_TITLE,
    textStyle: {
        color: '#244B60',
        fontSize: '12px'
    }
});

export const getTooltipForPeerComparison = (data, tooltipType) => {
    return {
        formatter: function (params) {
            const result = convertTooltipObject(params.name, data);
            const { seriesName } = params;

            if (seriesName === 'rmScenarioScore') {
                return (
                    '<span style="line-height: 30px;">Scenario</span>' +
                    '<span style="font-weight: 400; margin-left: 8px; margin-bottom: 5px; color: #929292;">' +
                    result.scenario +
                    '</span>' +
                    '<br><span style="line-height: 30px;">' +
                    tooltipType +
                    ' Rank </span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.rank +
                    '</span>' +
                    '<br><span style="line-height: 30px;">' +
                    tooltipType +
                    ' Risk Score </span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.score +
                    '</span>' +
                    '<br><span style="line-height: 30px;">Peer Risk Score</span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.peerScore +
                    '</span>' +
                    '<br><span style="line-height: 30px;">Outlier?</span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    (result.outlier === 1 ? 'Yes' : 'No')
                );
            } else if (
                ['marketScenarioScore', 'teamScenarioScore'].includes(
                    seriesName
                )
            ) {
                return (
                    '<span style="line-height: 30px;">Scenario</span>' +
                    '<span style="font-weight: 400; margin-left: 8px; margin-bottom: 5px; color: #929292;">' +
                    result.scenario +
                    '</span>' +
                    '<br><span style="line-height: 30px;">' +
                    tooltipType +
                    ' Rank </span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.rank +
                    '</span>' +
                    '<br><span style="line-height: 30px;">' +
                    tooltipType +
                    ' Risk Score </span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.score +
                    '</span>' +
                    '<br><span style="line-height: 30px;">Peer Risk Score</span>' +
                    '<span style="font-weight: 400; margin-left: 8px; color: #929292;">' +
                    result.peerScore
                );
            } else {
                return '';
            }
        },
        textStyle: {
            color: '#000000',
            fontWeight: 700,
            fontSize: '10px'
        },
        extraCssText:
            'box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08); ' +
            'border: 1px solid white; ' +
            'border-radius: 16px; ' +
            'padding: 16px;'
    };
};

export const getGridOptionsForPeerComparison = () => ({
    height: '50%',
    top: '20%',
    width: '70%',
    left: '25%',
    containLabel: true
});
export const getXAxisOptionsForPeerComparison = () => ({
    axisLine: {
        show: false
    },
    axisLabel: {
        show: false
    },
    splitLine: {
        show: false
    }
});

export const getYAxisOptionsForPeerComparison = () => ({
    type: 'category',
    data: ['Scenario 4', 'Scenario 3', 'Scenario 2', 'Scenario 1'],
    axisTick: {
        show: false
    },
    axisLine: {
        show: true,
        lineStyle: {
            color: '#E7E7E7'
        }
    },
    axisLabel: {
        show: false
    }
});
export const getYAxisLabelsForPeerComparison = () => {
    return {
        scenario1: {
            type: 'text',
            style: {
                text: 'Scenario 1',
                font: 'normal 400 12px "Outfit", sans-serif',
                fill: '#929292'
            },
            cursor: 'default',
            top: 100,
            right: '77.5%'
        },
        scenario2: {
            type: 'text',
            style: {
                text: 'Scenario 2',
                font: 'normal 400 12px "Outfit", sans-serif',
                fill: '#929292'
            },
            cursor: 'default',
            top: 152,
            right: '77.5%'
        },
        scenario3: {
            type: 'text',
            style: {
                text: 'Scenario 3',
                font: 'normal 400 12px "Outfit", sans-serif',
                fill: '#929292'
            },
            cursor: 'default',
            top: 206,
            right: '77.5%'
        },
        scenario4: {
            type: 'text',
            style: {
                text: 'Scenario 4',
                font: 'normal 400 12px "Outfit", sans-serif',
                fill: '#929292'
            },
            cursor: 'default',
            top: 257,
            right: '77.5%'
        }
    };
};

export const generateSeriesOptionsForPeerComparison = (
    type,
    seriesOneData,
    seriesTwoData
) => [
    {
        name: `${type}ScenarioScore`,
        type: 'bar',
        data: seriesOneData,
        barGap: '-148%',
        yAxisIndex: 0,
        zlevel: 2,
        color: '#244B60',
        colorBy: 'series',
        label: {
            show: true,
            position: 'right',
            fontFamily: 'Outfit',
            fontSize: 10,
            fontWeight: 400,
            color: '#244B60'
        },
        barWidth: 18,
        emphasis: {
            focus: 'self'
        }
    },
    {
        name: `${type}PeerScore`,
        cursor: 'auto',
        type: 'bar',
        data: seriesTwoData,
        yAxisIndex: 0,
        emphasis: {
            disabled: true
        },
        zlevel: 1,
        color: '#CECECE',
        colorBy: 'series',
        itemStyle: {
            opacity: 1
        },
        barWidth: 36
    }
];

export const generateTrendAnalysisYAxisMin = (valueList) =>
    valueList ? Math.min(...valueList) : 0;
